import './styles.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import I18n from 'lib/i18n'
import React, { useState, useRef, useEffect } from 'react'

export default function MobilePopularActivities ({ activities }) {
  return (
    <Tabs activities={activities}>
      {activities.map(({ id, categoryTitle, subCategories }) => {
        return (
          <Tab key={id} label={categoryTitle}>
            {subCategories.map(({ title, id, url }) => (
              <div className='sub-category-container' key={id}>
                <a href={url} className='sub-category'>
                  {title}
                </a>
              </div>
            ))}
          </Tab>
        )
      })}
    </Tabs>
  )
}

const Tabs = ({ children, activitiesObj }) => {
  // render UI with first Tab as active in the first time
  const [activeTab, setActiveTab] = useState(React.Children.toArray(children)[0].props.label)
  const [activities, setActivities] = useState(activitiesObj)
  const [showLeftArrow, setShowLeftArrow] = useState(I18n.locale === 'ar')
  const [showRightArrow, setShowRightArrow] = useState(I18n.locale !== 'ar')

  const navRef = useRef()
  let content
  let buttons = []

  const changeTab = tab => {
    setActiveTab(tab)
  }

  const handleNav = direction => {
    if (direction === 'left') {
      navRef.current.scrollLeft -= 50
    } else {
      navRef.current.scrollLeft += 50
    }
  }

  const handleScroll = e => {
    const maxOffset = e.target.scrollWidth - e.target.clientWidth
    if (Math.abs(e.target.scrollLeft) > 0 && Math.abs(e.target.scrollLeft) < maxOffset) {
      // start moving
      setShowLeftArrow(true)
      setShowRightArrow(true)
    } else if (Math.abs(e.target.scrollLeft) === maxOffset) {
      // rich end of scroll
      I18n.locale === 'ar' ? setShowLeftArrow(false) : setShowRightArrow(false)
    } else if (Math.abs(e.target.scrollLeft) === 0) {
      // back to initial point
      I18n.locale === 'ar' ? setShowRightArrow(false) : setShowLeftArrow(false)
    }
  }

  useEffect(() => {
    navRef.current.addEventListener('scroll', handleScroll)
    return function cleanupListener () {
      navRef.current.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <div className='tabs-container'>
      {React.Children.map(React.Children.toArray(children), child => {
        buttons.push(child.props.label)
        if (child.props.label === activeTab) content = child.props.children
      })}
      <div className='arrows-container'>
        <TabButtons activeTab={activeTab} buttons={buttons} changeTab={changeTab} navRef={navRef} />
        <div className='bar-bottom' />
        <button
          type='button'
          className='arrow-left'
          onClick={() => handleNav('left')}
          style={{ display: showLeftArrow ? 'flex' : 'none' }}
        >
          <div style={{ backgroundColor: '#fff' }}>
            <FontAwesomeIcon icon={faChevronLeft} />
          </div>
        </button>
        <button
          type='button'
          className='arrow-right'
          onClick={() => handleNav('right')}
          style={{ display: showRightArrow ? 'flex' : 'none' }}
        >
          <div style={{ backgroundColor: '#fff' }}>
            <FontAwesomeIcon icon={faChevronRight} />
          </div>
        </button>
      </div>
      <div className='tab-content'>{content}</div>
    </div>
  )
}

const TabButtons = ({ buttons, changeTab, activeTab, navRef }) => {
  return (
    <div className='tab-buttons no-scrollbar' ref={navRef}>
      {buttons.map((button, key) => {
        return (
          <button key={key} className={button === activeTab ? 'active' : ''} onClick={() => changeTab(button)}>
            {button}
          </button>
        )
      })}
    </div>
  )
}

const Tab = props => {
  return <>{React.Children.toArray(props.children)}</>
}
